/**
 * DevExtreme (esm/__internal/grids/new/grid_core/data_controller/public_methods.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    keysEqual
} from "../../../../data/m_utils";
export function PublicMethods(GridCore) {
    return class extends GridCore {
        getDataSource() {
            return this.dataController.dataSource.peek()
        }
        byKey(key) {
            const items = this.getDataSource().items();
            const store = this.getDataSource().store();
            const keyExpr = store.key();
            const foundItem = items.find((item => keysEqual(keyExpr, key, this.keyOf(item))));
            if (foundItem) {
                return Promise.resolve(foundItem)
            }
            return store.byKey(key)
        }
        getCombinedFilter() {
            return this.dataController.getCombinedFilter()
        }
        keyOf(obj) {
            return this.dataController.getDataKey(obj)
        }
        pageCount() {
            return this.dataController.pageCount.peek()
        }
        pageSize(value) {
            if (void 0 === value) {
                return this.dataController.pageSize.peek()
            }
            this.dataController.pageSize.value = value
        }
        pageIndex(newIndex) {
            if (void 0 === newIndex) {
                return this.dataController.pageIndex.peek()
            }
            this.dataController.pageIndex.value = newIndex;
            return this.dataController.waitLoaded()
        }
        totalCount() {
            return this.dataController.totalCount.peek()
        }
    }
}
